import { createHook } from '@atomify/hooks';

import { Store, Subscribe } from '../store/store.types';
/**
 * Store wrapper for functional components
 * @template T
 * @param {Store<T>} store
 */
export const useStore = <T, S extends string = string>(store: Store<T, S>) =>
    createHook<[T, Subscribe<T>, T]>({
        onDidLoad: () => {
            const state = store.getState();
            const subscribe = store.subscribe;
            const prevState = store.getPrevState();

            return [state, subscribe, prevState];
        },
    });
